module.exports = __webpack_public_path__ + "static/media/saving.cd2d7bc7.svg";